export default {
  "header": "What makes us awesome",
  "sections": [
    {
      "title": "Bold, Bright, Unique Styles",
      "body": "Magical kids' clothes you can't find anywhere else – designed by us",
      "svg": "LightningSvg"
    },
    {
      "title": "Soft & Stretchy Everything",
      "body": "Comfy clothes = happy people",
      "svg": "CloudsSvg"
    },
    {
      "title": "Next-level Details",
      "body": "Itch-free tags, soft lining, minimal seams. We could go on…",
      "svg": "StarSvg"
    },
    {
      "title": "Focus on Fit",
      "body": "We design single sizes 2 - 14",
      "svg": "ShirtsSvg"
    },
    {
      "title": "100% Washer Friendly",
      "body": "Including the sequins",
      "svg": "WashingMachineSvg"
    },
    {
      "title": "20% off 4+ Items",
      "body": "Automatic savings every single day",
      "svg": "CashSvg"
    },
    {
      "title": "Female Founder",
      "body": "(Trust her, she’s a mom!)",
      "svg": "FounderSvg"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/valuePropSection/defaultProps.js